import '@angular/localize';

/**
 * @fileoverview Configuration file for the Spreadsheet library.
 * Contains purely static values, fallback texts, and default configurations.
 */

export const SPREADSHEET_CONFIG = {
  texts: {
    loading: $localize`:@@spreadsheet.loading:Initializing Spreadsheet Engine...`,
    validationErrorTitle: $localize`:@@spreadsheet.validationErrorTitle:Validation Error`,
    invalidType: $localize`:@@spreadsheet.invalidType:Invalid data type. Expected`,
    notInEnum: $localize`:@@spreadsheet.notInEnum:Value must be one of the allowed options.`,
    requiredField: $localize`:@@spreadsheet.requiredField:This field cannot be empty.`,
    updateSuccess: $localize`:@@spreadsheet.updateSuccess:Row updated successfully.`,
    missingRequiredFields: $localize`:@@spreadsheet.missingRequiredFields:Missing Required Fields`,
    missingRequiredFieldsDesc: $localize`:@@spreadsheet.missingRequiredFieldsDesc:Please fill all required fields to save the new record.`,
    actionBlocked: $localize`:@@spreadsheet.actionBlocked:Action Blocked`,
    actionBlockedDesc: $localize`:@@spreadsheet.actionBlockedDesc:Adding or removing columns/rows is disabled in this view.`,
    invalidRowsSkipped: $localize`:@@spreadsheet.invalidRowsSkipped:Some rows have invalid input and were not saved. You can find these errors highlighted in red, please fix the errors and try again.`
  },
  univerConfig: {
    id: 'rapider-workbook',
    name: 'Rapider Entity Data',
    sheetId: 'sheet1',
    sheetName: 'Data'
  }
};